import React from 'react';
type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};
const RefreshIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = '#F2D093',
    strokeWidth = '1',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" stroke={strokeColor}
        strokeWidth={strokeWidth} strokeLinecap="round"
        strokeLinejoin="round" />
      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" stroke={strokeColor}
        strokeWidth={strokeWidth} strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
};

export default RefreshIcon;
